var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9243 3.88889H2.42432C1.17932 3.88889 0.174316 4.93111 0.174316 6.22222V10.8889H3.17432V14H12.1743V10.8889H15.1743V6.22222C15.1743 4.93111 14.1693 3.88889 12.9243 3.88889ZM10.6743 12.4444H4.67432V8.55556H10.6743V12.4444ZM12.9243 7C12.5118 7 12.1743 6.65 12.1743 6.22222C12.1743 5.79444 12.5118 5.44444 12.9243 5.44444C13.3368 5.44444 13.6743 5.79444 13.6743 6.22222C13.6743 6.65 13.3368 7 12.9243 7ZM12.1743 0H3.17432V3.11111H12.1743V0Z",
    fill: "#255986"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIcon);
export default __webpack_public_path__ + "static/media/print-icon.d2b751e1ef04fe61b6baeb952e39172a.svg";
export { ForwardRef as ReactComponent };